// Shared SEO constants.
//
// These files are .mjs on purpose. They are imported from TWO places with very
// different module systems: webpack (via src/seo/Seo.jsx, during the CRA build)
// and Node (via api/render.mjs, at request time on Vercel). package.json has no
// "type": "module", so a plain .js file here would be treated as CommonJS by
// Node and blow up on `export`. The .mjs extension makes both resolvers agree.
//
// Hard rules for everything in src/seo/:
//   - no JSX, no React, no `window`, no `document`
//   - no process.env.REACT_APP_* (inlined at CRA build time, undefined in the
//     serverless function - anything environmental arrives as an argument)
//   - explicit file extensions on every relative import (Node ESM requires them)

export const SITE_ORIGIN = "https://www.zecadofragrance.com";

export const BRAND = "Zecado Fragrance";
export const BRAND_SHORT = "Zecado";
export const CURRENCY = "USD";
export const CONTACT_EMAIL = "info@zecadofragrance.com";

export const SOCIAL_PROFILES = [
  "https://www.instagram.com/zecado_/",
  "https://www.tiktok.com/@zecadofragrance",
];

export const DEFAULT_OG_IMAGE = "/og-image.jpg";
export const LOGO_PATH = "/logo512x512.png";

// Route classes that must never enter the index. `follow` rather than `nofollow`
// everywhere except search: these pages still link onward to real catalogue
// pages and that link equity should keep flowing.
export const NOINDEX = "noindex, follow";
export const NOINDEX_NOFOLLOW = "noindex, nofollow";
export const INDEX = "index, follow, max-image-preview:large, max-snippet:-1";
